class PaginationCtrl {
    maxSize = 5; //  maximum count pages into pagination
    pages: any[] = []; // container for number of pages
    enable = true; // show or hide general element
    totalPages: number;
    currentMaxSize: number;
    page: number;
    noPrevious: boolean;
    noNext: boolean;
    ngModelCtrl: ng.INgModelController;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery) {
        this.ngModelCtrl = this.$element.controller('ngModel');
        this.ngModelCtrl.$render = () => this.render();
        // calculate new values if totalPages is changed
        $scope.$watch(() => this.totalPages, (val) => {
            if (val) {
                this.enable = this.totalPages > 1;
                this.currentMaxSize = this.totalPages >= this.maxSize ? this.maxSize : this.totalPages;
                this.render();
            }
        });
    }

    render() {
        const viewValue = parseInt(this.ngModelCtrl.$viewValue, 10) || 1;
        if (viewValue > 0 && viewValue <= this.totalPages) {
            this.page = viewValue;
            this.noPrevious = viewValue === 1;
            this.noNext = viewValue === this.totalPages;
            this.createPages();
        }
    }

    createPages() {
        this.pages = [];
        let startPage = Math.max(this.page - Math.floor(this.currentMaxSize / 2), 1),
            endPage = startPage + this.currentMaxSize - 1;

        if (endPage > this.totalPages) {
            endPage = this.totalPages;
            startPage = endPage - this.currentMaxSize + 1;
        }

        // Add page number
        for (let number = startPage; number <= endPage; number++) {
            this.pages.push({
                value: number,
                text: number,
                active: number === this.page
            });
        }
    }

    selectPage(page: number) {
        if (this.page !== page && page > 0 && page <= this.totalPages) {
            this.ngModelCtrl.$setViewValue(page);
            this.ngModelCtrl.$render();
        }
    }
}

angular.module('animatronApp.profileProject').component('pagination', {
        require: {ngModelCtrl: 'ngModel'},
        bindings: {
            totalPages: '=',
            maxSize: '=?'
        },
        controller: PaginationCtrl,
        controllerAs: 'PaginationCtrl',
        templateUrl: require('pagination.html')
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/paginationDirective.ts